<template>
        <!-- <div class="grid-x" :style="{height:banheight,backgroundColor:banbackcol}">

            <div class="cell text-center" >
        
                
                    <div  v-html="banners[1].Html"></div>
            
            
            </div>
        </div> -->
     <div
        v-if="showBanner"
        class="grid-x"
        :style="{height: banheight, backgroundColor: banbackcol}">

        <div class="cell text-center">
            <div ref="adContainer" v-html="banners[1].Html"></div>
        </div>

    </div>
</template>

<script>

    export default {
        name: "bannerad",
        data: function () {
            return {
                banners: this.bannertype,
                showBanner: false
            }
        },
        props: {

            bannertype: Array,
            bannerdivheight: { type: String, default: '64px' },
            bannerbackcolour: {type: Boolean, default: false},
            actualbanbackcolour: {type: String, default: '#0d0638'}  
        },
        computed: {
                banbackcol() {
                   return this.bannerbackcolour == true ? banners[0].Html: this.actualbanbackcolour
                },
                banheight() {
                    return  this.banners[1] !== undefined ?  this.bannerdivheight   : 0
                }

        },mounted() {

    this.$nextTick(() => {

        setTimeout(() => {

            const ad = this.$refs.adContainer;

            if (!ad) return;

            // Has anything useful appeared?
            const hasContent =
                ad.querySelector("iframe") ||
                ad.querySelector("img") ||
                ad.textContent.trim() !== "";

            this.showBanner = !!hasContent;

        }, 1000);

    })

},




        created() {
          

        }

    }


</script>